module.exports = __webpack_public_path__ + "media/images/delete-9cd0780866c2238fc64fb6d1059124f9.svg";